'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Checkbox = require('../../../inputs/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ISSUE 剛新增 condtion 時不會 buildQuery
// 是否改成 all, true, false 三個選項，而不是一個 checkbox
function CheckboxCondition(props) {
  var linkState = props.linkState,
      style = props.style;

  return _react2.default.createElement(
    'div',
    { className: style.searchWidget },
    _react2.default.createElement(
      'div',
      { className: style['checkbox-container'], style: { marginLeft: 10 } },
      _react2.default.createElement(_Checkbox2.default, linkState('check'))
    )
  );
}

var func = _propTypes2.default.func,
    object = _propTypes2.default.object;

CheckboxCondition.propTypes = {
  linkState: func.isRequired,
  style: object.isRequired
};

CheckboxCondition.buildQuery = function buildCheckboxQuery(_ref) {
  var check = _ref.check;

  return check ? { $eq: true } : { $ne: true };
};

exports.default = CheckboxCondition;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocList/QueryEditor/ConditionEditor/CheckboxCondition.js
// module id = 1699
// module chunks = 0